// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1ZOPW","title":"Header_title__-Szid","left":"Header_left__38XxE","clinicName":"Header_clinicName__4etPc"};